<!--
 * @Description: 预约赎回列表
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-02-27 13:25:48
 * @LastEditors: situgen@szkingdom.com
-->
<template>
    <div>
        <div :class="'bizcomp-order-sell-list bizcomp ' + className">
            <div class="sell-list-contain">
                <el-table
                    :data="sellArr"
                    style="width: 100%"
                    class="tab-list-tit table-list"
                    height="750"
                >
                    <el-table-column prop="fundname" label="产品名称" align="left" width="200">
                        <template slot-scope="scope">
                            <p class="table-fund-name">{{ scope.row.fundname }}</p>
                            <p class="table-fund-code">{{ scope.row.fundcode }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="depositcard" label="扣款账号" align="center" width="200">
                        <template slot-scope="scope">
                            {{
                                $cache.getDict("110080", scope.row.bankcode).substr(-4, 4) +
                                "【**" +
                                scope.row.depositcard.substr(-4, 4) +
                                "】"
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="currentshare"
                        label="持有份额"
                        align="center"
                        :formatter="formatterNum"
                    ></el-table-column>
                    <el-table-column
                        prop="availableShare"
                        label="可用份额"
                        align="center"
                        :formatter="formatterNum"
                    ></el-table-column>
                    <el-table-column
                        prop="preredeemvol"
                        label="已预约赎回份额"
                        align="center"
                        :formatter="formatterNum"
                    ></el-table-column>
                    <el-table-column
                        prop="enddate"
                        label="赎回开放日"
                        align="center"
                        :formatter="formatterDate"
                    ></el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <span
                                v-if="
                                    (scope.row.redeemflag == '0' || scope.row.redeemflag == '1') &&
                                    scope.row.availableShare > 0
                                "
                                class="sell-btn"
                                v-on:click="toSell(scope.row)"
                            >
                                {{ scope.row.redeemflag == "0" ? "预约赎回" : "赎回" }}
                            </span>
                            <span v-else class="no-sell-btn">不能赎回</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <footerQuestions
            v-if="$const.warmReminderDisplay"
            class="mt-98"
            :warning-html="warningHtml"
        ></footerQuestions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";
import fundApi from "@/api/fund";

export default {
    name: "MyOrder",
    components: {
        footerQuestions
    },
    mixins: [mixin],
    data() {
        return { sellArr: [], warningHtml: "" };
    },
    created() {
        const fundInfo = JSON.parse(sessionStorage.getItem("sellfund"));
        this.queryShortShareDetail(fundInfo);
        this.warningHtml = warningHtml.warningHtml8;
    },
    methods: {
        formatterNum(row, column, value) {
            if (row.redeemflag == "1") {
                // 已预约赎回份额显示 --
                if (column.property == "preredeemvol") {
                    return "--";
                }
            }
            return this.$util.fmtNum(value);
        },
        formatterDate(row, column, value) {
            // 如果是普通赎回，显示 --
            if (row.redeemflag == "1") {
                return "--";
            }
            return this.$util.fmtDate(value);
        },
        async queryShortShareDetail(fundInfo) {
            const fundcode = fundInfo.fundcode;
            const resArr = await fundApi.combQueryShortShareDetailTotal({
                fundcode: fundcode
            });
            if (resArr.data && resArr.data.data) {
                const resCopy = JSON.parse(JSON.stringify(resArr.data.data));
                resArr.data.data.forEach((item, index) => {
                    item.fundArr = [resCopy[index]];
                    item.fundArr[0].paycenterid = item.paychannel;
                    item.fundArr[0].index = "0";
                    if (item.redeemflag === "1") {
                        item.fundArr[0].usableremainshare = item.usableremainshare;
                        item.availableShare = item.usableremainshare;
                        item.fundArr[0].freezeremainshare =
                            Number(item.preredeemvol) + Number(item.freezeremainshare);
                    } else {
                        item.fundArr[0].usableremainshare = item.canredeemvol;
                        item.fundArr[0].freezeremainshare = item.preredeemvol;
                        item.availableShare = item.canredeemvol;
                    }
                    // 查询fundArr中的transactionaccountid是否和当前item的transactionaccountid一致，如果一直致，则赋值sourceflag
                    const fundArrFilter = fundInfo.fundArr.filter((fundItem) => {
                        return fundItem.transactionaccountid === item.transactionaccountid;
                    });
                    if (fundArrFilter.length > 0) {
                        // 如果fundArrFilter[0]中的key存在但是item.fundArr[0]中不存在，则赋值
                        for (const key in fundArrFilter[0]) {
                            if (
                                Object.prototype.hasOwnProperty.call(fundArrFilter[0], key) &&
                                !Object.prototype.hasOwnProperty.call(item.fundArr[0], key)
                            ) {
                                item.fundArr[0][key] = fundArrFilter[0][key];
                            }
                        }
                    }
                    if (item.redeemflag == "0") {
                        item.way = "25";
                    } else {
                        item.way = "24";
                    }
                    this.sellArr.push(item);
                });
            }
        },
        toSell(fundInfo) {
            sessionStorage.setItem("sellfund", JSON.stringify(fundInfo));
            this.$router.push({ name: "sellfund", query: { fundcode: fundInfo.fundcode } });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-order-sell-list {
    background: #ffffff;
    .sell-list-contain {
        padding: 20px 20px 0;
        .table-list {
            border-left: 1px solid #f1f1f1;
            border-right: 1px solid #f1f1f1;
            font-size: 14px;
            color: #333333;
            font-weight: bold;
            .table-fund-name {
                font-size: 16px;
            }
            .table-fund-code {
                color: #999999;
            }
            .sell-btn {
                font-size: 14px;
                font-weight: normal;
                color: var(--color-primary);
                cursor: pointer;
            }
            .no-sell-btn {
                font-size: 14px;
                font-weight: normal;
                color: #999999;
            }
        }
    }
    :deep(.el-table) {
        th {
            background: #f9f9f9 !important;
            color: #666666;
        }
    }
    .mt-98 {
        margin-top: 98px;
    }
}
</style>
